import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import { useCallback, useMemo } from 'react';
import { useInstanceContext } from '../context/instance/instanceContext';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { CloseIcon } from '../icons/closeIcon';
import { thunkOpenDirectMessagesToPlayer } from '../redux/actions/directMessagesActions';
import { thunkCloseToast } from '../redux/actions/toastsActions';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { ALL_TOAST_TYPE_PROPERTIES } from '../types/toastTypes';
import { assertUnreachable } from '../utils/tsUtils';
import { IconWithLabelDisplay } from './iconWithLabelDisplay';
function getSnackbarAnchorOrigin(instanceId, numInstances) {
    // TODO: Update this when numInstances > 4 ? like 6? 9?
    if (numInstances === 4) {
        switch (instanceId) {
            case 0: {
                return {
                    vertical: 'top',
                    horizontal: 'left'
                };
            }
            case 1: {
                return {
                    vertical: 'top',
                    horizontal: 'right'
                };
            }
            case 2: {
                return {
                    vertical: 'bottom',
                    horizontal: 'left'
                };
            }
            case 3: {
                return {
                    vertical: 'bottom',
                    horizontal: 'right'
                };
            }
        }
    }
    if (numInstances === 2) {
        switch (instanceId) {
            case 0: {
                return {
                    vertical: 'top',
                    horizontal: 'center'
                };
            }
            case 1: {
                return {
                    vertical: 'bottom',
                    horizontal: 'center'
                };
            }
        }
    }
    return {
        vertical: 'top',
        horizontal: 'center'
    };
}
export const ToastsContainer = () => {
    const dispatch = useAppDispatch();
    // TODO: Improve this inefficient selector:
    const toasts = useAppSelector((state) => state.toasts.toasts);
    const socketSend = useSocketSend();
    const { instanceId, numInstances } = useInstanceContext();
    const anchorOrigin = useMemo(() => getSnackbarAnchorOrigin(instanceId, numInstances), [instanceId, numInstances]);
    const onClickClose = useCallback((key) => {
        dispatch(thunkCloseToast(key));
    }, [dispatch]);
    const onClickView = useCallback(() => {
        if (!toasts.length) {
            return;
        }
        const action = toasts[0].action;
        if (action) {
            switch (action.type) {
                case 'open-direct-messages': {
                    dispatch(thunkOpenDirectMessagesToPlayer(action.playerIdName, socketSend));
                    break;
                }
                default: {
                    assertUnreachable(action.type);
                }
            }
        }
    }, [dispatch, socketSend, toasts]);
    if (!toasts.length) {
        return null;
    }
    const { type: toastType, key, message: messageStr, action } = toasts[0];
    const { autoHideDuration, svgIconComponent: SvgIconComponent, style } = ALL_TOAST_TYPE_PROPERTIES[toastType];
    const message = SvgIconComponent ? (_jsx(IconWithLabelDisplay, { label: messageStr, icon: _jsx(SvgIconComponent, {}) })) : (messageStr);
    return (_jsx(Snackbar, { open: true, "aria-label": messageStr, message: message, anchorOrigin: anchorOrigin, autoHideDuration: autoHideDuration, onClose: (event, reason) => {
            if (reason === 'timeout') {
                // fired after any autoHideDuration timeout
                onClickClose(key);
            }
        }, action: _jsxs(_Fragment, { children: [action && (_jsx(Button, { color: 'primary', size: 'small', onClick: onClickView, variant: 'contained', children: "View" })), _jsx(IconButton, { size: 'small', "aria-label": 'Close Alert', onClick: () => onClickClose(key), children: _jsx(CloseIcon, { fontSize: 'small', color: 'inherit' }) })] }), css: style }));
};
